import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class BookingflightsService {
  constructor(private restService: RestService) {}

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('bookingflights/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('bookingflights/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('bookingflights/edit', val_id);
  }
  detail(val_id: number) {
    return this.restService.get('bookingflights/detail', val_id);
  }

  save(data: any) {
    return this.restService.save('bookingflights/save', data);
  }

  updateSave(data: any) {
    return this.restService.save('bookingflights/update/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('bookingflights/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('bookingflights/delete', val_id);
  }
}
